import { useEffect, useRef,useState} from "react";
import { getToken, getUserId,setInizio,setFine,getInizio,getFine,setInizioC,setFineC,getInizioC,getFineC } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/analisi.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,decodificaExtra,convertiValuta,convertiIdEscursione,convertiTipoStorage,convertiIdNoleggio,ordinaPerData,prendiNomePacchetto,coloreDaId,guadagnoEscursione,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,calcolaStipendioFisso,convertiCambi} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
function AnalisiEconomicaCasa() {
function riempiBuchi(dati, livello = 1, inizio, fine) {
  let current = inizio;

  if (livello === 1) { // mesi
    while (current <= fine) {
      const chiave = current.toFormat("yyyy-MM");
      if (!(chiave in dati)) dati[chiave] = 0;
      current = current.plus({ months: 1 });
    }
  }

  if (livello === 2) { // settimane
    while (current <= fine) {
      const chiave = `${current.weekYear}-W${String(current.weekNumber).padStart(2, "0")}`;
      if (!(chiave in dati)) dati[chiave] = 0;
      current = current.plus({ weeks: 1 });
    }
  }

  if (livello === 3) { // giorni
    while (current <= fine) {
      const chiave = current.toISODate();
      if (!(chiave in dati)) dati[chiave] = 0;
      current = current.plus({ days: 1 });
    }
  }

  return dati;
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function handleClick(cellInfoGen,periodo,utenti,datiCambi) {
    const content=mostraDettagliPeriodo(cellInfoGen,periodo,utenti,datiCambi)
    $("#infoDettagli").dxPopup("instance").option("contentTemplate", () => content);
    $("#infoDettagli").dxPopup("instance").show();
}
function mostraDettagliPeriodo(cellInfoGen,periodo,utenti,datiCambi){
    let chiave=""
    const data=DateTime.fromJSDate(cellInfoGen.data.data, { zone: 'utc' })
    const chiaveMese=data.toFormat("yyyy-MM")
    const chiaveGiorno=data.toISODate()
    const chiaveSettimana=`${data.weekYear}-W${String(data.weekNumber).padStart(2, "0")}`
    if ($('#divisioneDati').dxTabs("instance").option("selectedIndex")===0){
        chiave=chiaveMese
    }
    else if ($('#divisioneDati').dxTabs("instance").option("selectedIndex")===1)
    chiave=chiaveSettimana
    else chiave=chiaveGiorno
    const periodoInteressato=periodo[chiave]
    let formattedRowsLezione=[]
    let formattedRowsNoleggi=[]
    const divGen=document.createElement("div")
    const titoloEntrate=document.createElement("h1")
    titoloEntrate.innerText="Suddivisione entrate"
    if (periodoInteressato["entrate"])divGen.appendChild(titoloEntrate)
    const divLezioni=document.createElement("div")
    const divNoleggi=document.createElement("div")
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["prenotazioni"]) divGen.appendChild(divLezioni)
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["extra"]) divGen.appendChild(divNoleggi)
    const titoloLezioni=document.createElement("h2")
    titoloLezioni.innerText="Dettagli Prenotazioni"
    const titoloNoleggi=document.createElement("h2")
    titoloNoleggi.innerText="Dettagli Extra"
    const divTabellaLez=document.createElement("div")
    const divTabellaNol=document.createElement("div")
    divLezioni.appendChild(titoloLezioni)
    divTabellaLez.id="datagridDettagliPrenotazioni"
    divTabellaLez.style.maxHeight = "500px"
    divNoleggi.appendChild(titoloNoleggi)
    divNoleggi.appendChild(divTabellaNol)
    divTabellaNol.id="datagridDettagliExtra"
    divTabellaNol.style.maxHeight = "500px"
    divLezioni.appendChild(divTabellaLez)
    const divSpese=document.createElement("div")
    if (periodoInteressato["spese"]) divGen.appendChild(divSpese)
    const titoloSpese=document.createElement("h1")
    titoloSpese.innerText="Suddivisione spese"
    divSpese.appendChild(titoloSpese)
    const divTabellaSpese=document.createElement("div")
    divSpese.appendChild(divTabellaSpese)
    divTabellaSpese.id="datagridDettagliSpese"
    divTabellaSpese.style.maxHeight = "500px"
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["prenotazioni"]){
         formattedRowsLezione=periodoInteressato["entrate"]["prenotazioni"].map((row, index) => ({
            id: index,
            checkin: convertDate(row.bookingcheckindate).toISO({ includeOffset: false }),
            nome: row.bookingreference,
            checkout: convertDate(row.bookingcheckoutdate).toISO({ includeOffset: false }),
            costo: row.costoStanza,
          }));
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["extra"]){
         formattedRowsNoleggi=periodoInteressato["entrate"]["extra"].map((row, index) => ({
            id: index,
            data: convertDate(row.dataExtra).toISO({ includeOffset: false }),
            nome: row.nomeExtra,
            tipo: decodificaExtra(row.extratype),
            costo: row.extracost,
          }));
    }
    let formattedRowsSpese=[]
    if (periodoInteressato["spese"]){
        for (let spesa of periodoInteressato["spese"]){
            formattedRowsSpese=[...formattedRowsSpese,{
                "data":convertDate(spesa.transactiondate.slice(0,8)).toISO({ includeOffset: false }),
                categoria:spesa.registrytypedescr,
                sottocategoria:spesa.registrysubtypedescr,
                "note": spesa.transactionnotes,
                importo:`${spesa.transactionvalue.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`
            }]
        }
    }
    const allineamento="center"
    setTimeout(()=>{
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["prenotazioni"]){
        $("#datagridDettagliPrenotazioni").dxDataGrid({
            dataSource:formattedRowsLezione,
            columns:[{dataField:"checkin",caption:"Data Check-in",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"checkout",caption:"Data Check-in",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"nome",caption:"Nome Cliente",alignment:allineamento,},
            {dataField:"costo",caption:"Costo prenotazione",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["entrate"]&&periodoInteressato["entrate"]["extra"]){
        $("#datagridDettagliExtra").dxDataGrid({
            dataSource:formattedRowsNoleggi,
            columns:[{dataField:"data",caption:"Data",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"nome",caption:"Nome cliente",alignment:allineamento,},
            {dataField:"tipo",caption:"Tipo extra",alignment:allineamento},
            {dataField:"costo",caption:"Costo extra",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    if (periodoInteressato["spese"]){
        $("#datagridDettagliSpese").dxDataGrid({
            dataSource:formattedRowsSpese,
            columns:[
            {dataField:"data",caption:"Data Spesa",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"categoria",caption:"Categoria Spesa",alignment:allineamento},
            {dataField:"sottocategoria",caption:"Sottocategoria Spesa",alignment:allineamento,},
            {dataField:"note",caption:"Note Spesa",alignment:allineamento,},
            {dataField:"importo",caption:"Importo spesa",alignment:allineamento,},
            ],
            showBorders: true,
            scrolling:{
            useNative:true
            },
            rowAlternationEnabled: true,
            columnAutoWidth: true,
            paging: { pageSize: 50 },
            height: "auto",
            width: "100%",
            columnHidingEnabled: true,
        })
    }
    },0)
    return divGen
}
    function apriPopupDettagliSpesa(evento, listaCosti,listaNumeri) {
  const dettagli = listaCosti[evento.target.argument];
  const dataSourceDettagliSpese = Object.entries(dettagli).map(
    ([category, valore]) => ({ category, valore })
  );
  let dataSourceDettagliSpeseNumeri=[]
  if (listaNumeri){
  const dettagli2 = listaNumeri[evento.target.argument];

   dataSourceDettagliSpeseNumeri = Object.entries(dettagli2).map(
    ([category, valore]) => ({ category, valore })
  );}
$("#infoDettagli").dxPopup("instance").option(
            "title",
            `Dettagli ${evento.target.argument}`
          );
  $("#infoDettagli").dxPopup("instance").option("contentTemplate", () => {
    const divGen = document.createElement("div");
    const divGraf=document.createElement("div");
    const divTab=document.createElement("div");
    divGen.style.height="100%"
    divGen.style.width="100%"
    divGraf.id = "chartPieDettagliSpese";
    divTab.id = "tabsDettagliSpese";
    divGraf.style.height="100%"
    divGraf.style.width="100%"
    if (listaNumeri)
    divGen.appendChild(divTab)
    divGen.appendChild(divGraf)

    const tabsIconAndText=[
      { id: 0, text: 'Rappresentazione costo'},
      { id: 1, text: 'Rappresentazione numero'},
    ];
    setTimeout(() => {

      $("#chartPieDettagliSpese").dxPieChart({
        dataSource: dataSourceDettagliSpese,
        height:"100%",
        width:"100%",
        series: {
          argumentField: "category",
          valueField: "valore",
          label: {
            visible: true,
            connector: { visible: true },
            customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`;
    }
          },
        },
        export: {
          enabled: true,
          formats: ["PNG", "PDF", "JPEG", "SVG"],
          fileName: "grafico",
        },
        tooltip: {
          enabled: true,
          customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
        },
        legend: {
          horizontalAlignment: "center",
          verticalAlignment: "bottom",
        },
      });
      $('#tabsDettagliSpese').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
        if (newIndex===-1)newIndex=0
        if (newIndex===0)
        $("#chartPieDettagliSpese").dxPieChart("instance").option("dataSource",dataSourceDettagliSpese)
        else
        $("#chartPieDettagliSpese").dxPieChart("instance").option("dataSource",dataSourceDettagliSpeseNumeri)

      }
      })
      if (listaNumeri)
      $('#tabsDettagliSpese').dxTabs("instance").option("selectedIndex", 0)
    }, 0);

    return divGen;
  });

  $("#infoDettagli").dxPopup("instance").show();
}

    function creaKPI(titolo, valore,colore) {
  const box = document.createElement("div");
  box.className = "kpi-box flex-item"; // <-- aggiunto "flex-item"

  const title = document.createElement("div");
  title.className = "kpi-title";
  title.textContent = titolo;

  const val = document.createElement("div");
  val.className = `kpi-value ${colore}`;
  val.textContent = valore;

  box.appendChild(title);
  box.appendChild(val);
  return box;
}

    useEffect(() => {
        let inizioModIn=null
        let fineModIn=null
        let inizioModFin=null
        let fineModFin=null
        const fetchDati = async () => {
        const inizio= $("#dateBoxInizio").dxDateBox({
        label:"Data inizio",
        width:"45%",
        displayFormat: "dd/MM/yyyy",
        value: getInizioC() ? new Date(getInizioC()) : new Date(2024, 9, 1),
        onValueChanged: function (e){
            setInizioC(DateTime.fromJSDate(e.value).toISO())
        },
        onFocusOut: function(e){
            fineModIn=$("#dateBoxInizio").dxDateBox("instance").option("value")
            if (inizioModIn!==fineModIn){
                window.location.reload()
            }
        },
        onFocusIn: function(e){
            inizioModIn= $("#dateBoxInizio").dxDateBox("instance").option("value")
        },
        })
        const fine=$("#dateBoxFine").dxDateBox({
        label:"Data fine",
        width:"45%",
        displayFormat: "dd/MM/yyyy",
        onValueChanged: function (e){
            setFineC(DateTime.fromJSDate(e.value).toISO())
        },
        value: getFineC() ? new Date(getFineC()) : new Date(2025, 4, 1),
        onFocusOut: function(e){
            fineModFin=$("#dateBoxFine").dxDateBox("instance").option("value")
            if (inizioModFin!==fineModFin){
                window.location.reload()
            }
        },
        onFocusIn: function(e){
            inizioModFin= $("#dateBoxFine").dxDateBox("instance").option("value")
        },})

        $("#loadingOverlay").show()
        const inizioFiltro=DateTime.fromJSDate($("#dateBoxInizio").dxDateBox("instance").option("value")).toFormat("yyyyMMdd")
        const fineFiltro=DateTime.fromJSDate($("#dateBoxFine").dxDateBox("instance").option("value")).toFormat("yyyyMMdd")
        const filtroL=convertDate(inizioFiltro)
        let finePF=convertDate(fineFiltro)
        finePF=finePF.plus({hours:23})
        const datiPrenotazioni = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookings",
                })
        const camerePrenotazioni= await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    azione: "getLinkBookingRooms",
                })
        const datiPacchetti=[]
        const datiNoleggi=[]
        const periodi=[]
        const extraPrenotazioni = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBookingExtras",})
        const datiUtenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getUsers",})
        let datiCambi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExchanges",
                filtri:{"exchangefrom":parseInt(inizioFiltro)<=parseInt(DateTime.now().toFormat("yyyyMMdd"))?inizioFiltro:DateTime.now().toFormat("yyyyMMdd"),"exchangeto":(convertDate(fineFiltro).plus({days:1}).toFormat("yyyyMMdd")),"exchangerates":"USDEUR"+","+"USDKES"},
                })
        const spese = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "GetTransactions",})
        datiCambi=convertiCambi(datiCambi,["EURKES"])
        let entrateTot=0
        let crediti=0
        let entrateExtra=0
        $("#loadingOverlay").hide()
        let periodiDettagliati={1:{},2:{},3:{}}
        let tipiLezioni={}
        let numeriLezioni={}
        let tipiNoleggi={}
        let numeriNoleggi={}
        let tipiStorage={}
        let tipiMaglie={}
        let numeriMaglie={}
        let numeriStorage={}
        let tipiEscursioni={}
        let numeriEscursioni={}
        let entratePeriodi={1:{},2:{},3:{}}
        let stipendiPeriodi={1:{},2:{},3:{}}
        let spesePeriodi={1:{},2:{},3:{}}
        let speseTot=0
        let entratePrenotazioni=0
        let entrateMaglie=0
        let pagatoMaglie=0
        let pagatoLezioni=0
        let entrateNoleggi=0
        let pagatoNoleggi=0
        let entrateStorage=0
        let pagatoStorage=0
        let entrateEscursioni=0
        let speseEscursioni=0
        let pagatoEscursioni=0
        let stipendiPersonale={}
        let stipendiFissi=0
        let entratelezC=0
        let soldiFuori=[]
        for (let prenotazione of datiPrenotazioni){
            let costoExtra=0
            let costiExtra=0
            let listaExtraPrenotazioni=[]
            const notti=convertDate(prenotazione.bookingcheckoutdate).startOf('day').diff(convertDate(prenotazione.bookingcheckindate).startOf('day'), 'days').days
            let dataStorage=convertDate(prenotazione.bookingcheckindate)
            const giornoC=(prenotazione.bookingtotcost-costoExtra)/notti
            for (let extra of extraPrenotazioni){
                if (prenotazione.bookingid===extra.bookingid && filtroL<=dataStorage && finePF>=dataStorage){
                    costoExtra+=extra.extracost
                    extra.dataExtra=prenotazione.bookingcheckindate
                    extra.nomeExtra=prenotazione.bookingreference
                    let costoSing=0
                    if (extra.extracostuscurrency===1) {costiExtra+=extra.extracostus
                    costoSing=extra.extracostus
                    }
                    else {costiExtra+=extra.extracostus/(datiCambi[convertDate(prenotazione.bookingcheckindate).toFormat("yyyyMMdd")]?datiCambi[convertDate(prenotazione.bookingcheckindate).toFormat("yyyyMMdd")]:datiCambi[Object.keys(datiCambi).reduce((a, b) => (a > b ? a : b))])
                    costoSing=extra.extracostus/(datiCambi[convertDate(prenotazione.bookingcheckindate).toFormat("yyyyMMdd")]?datiCambi[convertDate(prenotazione.bookingcheckindate).toFormat("yyyyMMdd")]:datiCambi[Object.keys(datiCambi).reduce((a, b) => (a > b ? a : b))])
                    }
                    listaExtraPrenotazioni.push(extra)
                }
            }
            entrateExtra+=costoExtra-costiExtra
            prenotazione.costoStanza=(prenotazione.bookingtotcost*(1-(prenotazione.bookingdiscount/100)))-costoExtra
            if (filtroL<=dataStorage && finePF>=dataStorage){
                entratePrenotazioni+=(prenotazione.bookingtotcost*(1-(prenotazione.bookingdiscount/100)))-costoExtra
                entrateTot+=prenotazione.bookingadvancepaid
                if (Math.abs(prenotazione.bookingadvancepaid - prenotazione.bookingtotcost*(1-(prenotazione.bookingdiscount/100))) > 0.01){
                        soldiFuori.push(prenotazione)
                    }
                let chiaveMese=dataStorage.toFormat("yyyy-MM")
                let chiaveGiorno=dataStorage.toISODate()
                let chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`

                if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                    entratePeriodi[1][chiaveMese]+=((costoExtra-costiExtra))
                    if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                    entratePeriodi[3][chiaveGiorno]+=costoExtra-costiExtra
                    if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                    entratePeriodi[2][chiaveSettimana]+=costoExtra-costiExtra
                for (let i = 0; i < notti; i++) {
                    dataStorage=dataStorage.plus({days:i===0?0:1})
                    chiaveMese=dataStorage.toFormat("yyyy-MM")
                    chiaveGiorno=dataStorage.toISODate()
                    chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
                    if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                   if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
                   if (!("prenotazioni" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["prenotazioni"]=[]
                    if (!(periodiDettagliati[1][chiaveMese]["entrate"]["prenotazioni"].includes(prenotazione)))periodiDettagliati[1][chiaveMese]["entrate"]["prenotazioni"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["prenotazioni"],prenotazione]
                    if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                   if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
                   if (!("prenotazioni" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["prenotazioni"]=[]
                    if (!(periodiDettagliati[3][chiaveGiorno]["entrate"]["prenotazioni"].includes(prenotazione)))periodiDettagliati[3][chiaveGiorno]["entrate"]["prenotazioni"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["prenotazioni"],prenotazione]
                    if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                    if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                    if (!("prenotazioni" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["prenotazioni"]=[]
                    if (!(periodiDettagliati[2][chiaveSettimana]["entrate"]["prenotazioni"].includes(prenotazione)))periodiDettagliati[2][chiaveSettimana]["entrate"]["prenotazioni"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["prenotazioni"],prenotazione]
                for (let extra of listaExtraPrenotazioni){
                    if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                   if (!("entrate" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["entrate"]={}
                   if (!("extra" in periodiDettagliati[1][chiaveMese]["entrate"]))periodiDettagliati[1][chiaveMese]["entrate"]["extra"]=[]
                    if (!(periodiDettagliati[1][chiaveMese]["entrate"]["extra"].includes(extra)))periodiDettagliati[1][chiaveMese]["entrate"]["extra"]=[...periodiDettagliati[1][chiaveMese]["entrate"]["extra"],extra]
                    if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                   if (!("entrate" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["entrate"]={}
                   if (!("extra" in periodiDettagliati[3][chiaveGiorno]["entrate"]))periodiDettagliati[3][chiaveGiorno]["entrate"]["extra"]=[]
                    if (!(periodiDettagliati[3][chiaveGiorno]["entrate"]["extra"].includes(extra)))periodiDettagliati[3][chiaveGiorno]["entrate"]["extra"]=[...periodiDettagliati[3][chiaveGiorno]["entrate"]["extra"],extra]
                    if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                    if (!("entrate" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["entrate"]={}
                    if (!("extra" in periodiDettagliati[2][chiaveSettimana]["entrate"]))periodiDettagliati[2][chiaveSettimana]["entrate"]["extra"]=[]
                    if (!(periodiDettagliati[2][chiaveSettimana]["entrate"]["extra"].includes(extra)))periodiDettagliati[2][chiaveSettimana]["entrate"]["extra"]=[...periodiDettagliati[2][chiaveSettimana]["entrate"]["extra"],extra]
                }
                    if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                    entratePeriodi[1][chiaveMese]+=((giornoC))
                    if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                    entratePeriodi[3][chiaveGiorno]+=giornoC
                    if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                    entratePeriodi[2][chiaveSettimana]+=giornoC

                }
            }
        }
        for (let livello of Object.keys(entratePeriodi)) {
  entratePeriodi[livello] = riempiBuchi(entratePeriodi[livello], parseInt(livello), filtroL, finePF);
}
for (let livello of Object.keys(entratePeriodi)){
    for (let chiave of Object.keys(entratePeriodi[livello])){
        if (!(chiave in periodiDettagliati[livello])) periodiDettagliati[livello][chiave]={}
        if (!("entrate" in periodiDettagliati[livello][chiave]))periodiDettagliati[livello][chiave]["entrate"]={}
    }
}
        let speseDivise={}
        let speseGestione={}
        let speseStipendi=0
        let stipendiDivisi={}
        for (let spesa of spese){
            const dataSpesa=convertDate(spesa.transactiondate)
            if (filtroL<=dataSpesa && finePF>=dataSpesa){
                if (spesa.registrytypecategory===2){
                    let importo=0
                    if (spesa.transactioncurrency===1){
                        importo=spesa.transactionvalue
                    }
                    else {
                        importo=spesa.transactionvalue/datiCambi[spesa.transactiondate]
                    }
                    speseTot+=importo
                    const chiaveMese=dataSpesa.toFormat("yyyy-MM")
                    const chiaveGiorno=dataSpesa.toISODate()
                    const chiaveSettimana=`${dataSpesa.weekYear}-W${String(dataSpesa.weekNumber).padStart(2, "0")}`
                    if (!(chiaveMese in spesePeriodi[1]))spesePeriodi[1][chiaveMese]=0
                    spesePeriodi[1][chiaveMese]+=importo
                    if (!(chiaveGiorno in spesePeriodi[3]))spesePeriodi[3][chiaveGiorno]=0
                    spesePeriodi[3][chiaveGiorno]+=importo
                    if (!(chiaveSettimana in spesePeriodi[2]))spesePeriodi[2][chiaveSettimana]=0
                    spesePeriodi[2][chiaveSettimana]+=importo
                    if (!(spesa.registrytypedescr in speseGestione))speseGestione[spesa.registrytypedescr]=0
                    speseGestione[spesa.registrytypedescr]+=importo
                    if (!(spesa.registrytypedescr in speseDivise))speseDivise[spesa.registrytypedescr]={}
                    if (!(spesa.registrysubtypedescr in speseDivise[spesa.registrytypedescr]))speseDivise[spesa.registrytypedescr][spesa.registrysubtypedescr]=0
                    speseDivise[spesa.registrytypedescr][spesa.registrysubtypedescr]+=importo
                    if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
               if (!("spese" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["spese"]=[]
                periodiDettagliati[1][chiaveMese]["spese"]=[...periodiDettagliati[1][chiaveMese]["spese"],spesa]
                if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
               if (!("spese" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["spese"]=[]
                periodiDettagliati[3][chiaveGiorno]["spese"]=[...periodiDettagliati[3][chiaveGiorno]["spese"],spesa]
                if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                if (!("spese" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["spese"]=[]
                periodiDettagliati[2][chiaveSettimana]["spese"]=[...periodiDettagliati[2][chiaveSettimana]["spese"],spesa]

                }
            }
        }
        for (let prenotazione of soldiFuori){
            crediti+=(prenotazione.bookingtotcost*(1-(prenotazione.bookingdiscount/100))-prenotazione.bookingadvancepaid)
        }

        const divGen = document.getElementById("divGen");
        divGen.innerHTML = "";
        const box1=creaKPI("Entrate totali",`${entrateTot.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"black")
        divGen.appendChild(box1)
        const box2=creaKPI("Spese totali",`${speseTot.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"red")
        divGen.appendChild(box2)
        const box3=creaKPI("Guadagno totale",`${(entrateTot-speseTot).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,(entrateTot-speseTot)>0?"green":"red")
        divGen.appendChild(box3)
        const box4=creaKPI("Crediti da riscuotere",`${(crediti).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"yellow")
        divGen.appendChild(box4)
        const box5=creaKPI("Entrate con crediti",`${(crediti+entrateTot).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,"black")
        divGen.appendChild(box5)
        const box6=creaKPI("Guadagni con crediti",`${(crediti+entrateTot-speseTot).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`,(crediti+entrateTot-speseTot)>0?"green":"red")
        divGen.appendChild(box6)
        let profittoPeriodi={}
        for (let tipo in entratePeriodi){
            if (!(tipo in profittoPeriodi))profittoPeriodi[tipo]={}
            const allKeys2 = new Set([
              ...Object.keys(entratePeriodi[tipo]),
              ...Object.keys(stipendiPeriodi[tipo]),
              ...Object.keys(spesePeriodi[tipo]),
            ]);
            for (let giorno of allKeys2){
                const entrateCiclo=entratePeriodi[tipo][giorno]?entratePeriodi[tipo][giorno]:0
                const speseCiclo=spesePeriodi[tipo][giorno]?spesePeriodi[tipo][giorno]:0
                const stipendiCiclo=stipendiPeriodi[tipo][giorno]?stipendiPeriodi[tipo][giorno]:0
                profittoPeriodi[tipo][giorno]=entrateCiclo-speseCiclo-stipendiCiclo
            }
        }
        const dataSourceEntrate = [
          { category: "Prenotazioni", valore: entratePrenotazioni },
          { category: "Extra", valore: entrateExtra },

        ];
        let entrateDivise={"Prenotazioni":tipiLezioni,Noleggi:tipiNoleggi,Storage:tipiStorage,Escursioni:tipiEscursioni,Merch:tipiMaglie}
        let entrateDiviseNumeri={"Prenotazioni":numeriLezioni,Noleggi:numeriNoleggi,Storage:numeriStorage,Escursioni:numeriEscursioni,Merch:numeriMaglie}

        let dataSourceSpese=[]
        for (let i in speseGestione){
            dataSourceSpese=[...dataSourceSpese,{ category: i, valore: speseGestione[i] }]
        }

        const entrateDiv = entratePeriodi[1];
        const stipendiDiv = stipendiPeriodi[1];
        const speseDiv = spesePeriodi[1];
        const profittoDiv = profittoPeriodi[1];
        const chartData = [];
        const allKeys = new Set([
          ...Object.keys(entrateDiv),
          ...Object.keys(stipendiDiv),
          ...Object.keys(speseDiv),
          ...Object.keys(profittoDiv),
        ]);
        for (const key of allKeys) {
          const dt = DateTime.fromFormat(key, "yyyy-MM", { zone: "utc" });
          const jsDate = dt.toJSDate()
          chartData.push({
            date: jsDate,
            entrate: entrateDiv[key] || 0,
            stipendi: stipendiDiv[key] || 0,
            spese: speseDiv[key] || 0,
            profitto: profittoDiv[key] || 0,
          });
        }

    const tabsIconAndText = [
      { id: 0, text: 'Divisione mensile'},
      { id: 1, text: 'Divisione settimanale'},
      { id: 2, text: 'Divisione giornaliera'},
    ];
    $("#chartPieEntrate").dxPieChart({
  dataSource: dataSourceEntrate,
  width:"50%",
  height:"100%",
  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`;
    }
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
  },
  legend: {
    horizontalAlignment: "center",
    verticalAlignment: "bottom",
  },
  title: "Suddivisione delle Entrate",
});
    $("#chartPieSpese").dxPieChart({
  dataSource: dataSourceSpese,
  width:"50%",
  height:"100%",
  series: {
    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`;
    }
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  onPointClick:function(e){
  apriPopupDettagliSpesa(e,speseDivise)
  },
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
  },
  legend: {
    horizontalAlignment: "center",
    verticalAlignment: "bottom",
  },
  title: "Suddivisione delle Spese",
});
$("#chartContainer").dxChart({
  dataSource: chartData,
  zoomAndPan: {
    argumentAxis: "both",
    valueAxis: "both"
  },
  argumentAxis: {
    argumentType: "datetime",},
  scrollBar: {
      visible: false,
    },
  series: [{
      argumentField: "date",
      valueField: "entrate",
      name: "Entrate",
      type: "spline",
    },
    {
      argumentField: "date",
      valueField: "spese",
      name: "Spese",
      type: "spline",
    },
    {
      argumentField: "date",
      valueField: "profitto",
      name: "Profitto",
      type: "spline",
    }],
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
            html:
            "<b>Valore:</b> " + `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +`${DateTime.fromJSDate(pointInfo.argument).setLocale("it").toFormat("LLLL yyyy")}`
        };
      },
  },
  title: "Andamento Mensile"
});
let formattedRows = chartData.map((row, index) => ({
        id: index,
        data: row.date,
        entrate: row.entrate,
        spese: row.spese,
        stipendi: row.stipendi,
        profitto: row.profitto,
      }));
    const allineamento="center"
    $("#datagridDettagli").dxDataGrid({
        dataSource:formattedRows,
        columns:[{dataField: "data", caption: "Data riferimento", alignment:allineamento,customizeText:function (e){;return DateTime.fromJSDate(e.value).setLocale("it").toFormat("LLLL yyyy")}},
            {dataField: "entrate", caption: "Entrate totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "spese", caption: "Spese totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "profitto", caption: "Profitto totale", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
        {
            type: "buttons",
            width:"50px",
            buttons: [
              {
                hint: "Dettagli periodo",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() =>{
                      handleClick(cellInfo,periodiDettagliati[1],datiUtenti,datiCambi)}}
                    />
                  );
                },
              }
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },


    })
$('#divisioneDati').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
      if (newIndex===-1)newIndex=0
      const entrateDiv = entratePeriodi[newIndex+1];
        const stipendiDiv = stipendiPeriodi[newIndex+1];
        const speseDiv = spesePeriodi[newIndex+1];
        const profittoDiv = profittoPeriodi[newIndex+1];
        let total=0
        for (let i in entrateDiv){
            total+=entrateDiv[i]
        }
        let chartData = [];
        const allKeys = new Set([
          ...Object.keys(entrateDiv),
          ...Object.keys(stipendiDiv),
          ...Object.keys(speseDiv),
          ...Object.keys(profittoDiv),
        ]);
        for (const key of allKeys) {
          let dt=null
          let jsDate=null
        if (newIndex===0)
          {dt = DateTime.fromFormat(key, "yyyy-MM", { zone: "utc" });

          jsDate = dt.toJSDate()}
        else if (newIndex===1)
        {const [year, week] = key.split("-W");
          dt = DateTime.fromObject(
          { weekYear: +year, weekNumber: +week },
          { zone: "utc" }  // oppure "none" in Luxon 3.x
        ).startOf("week")
        jsDate = dt.toJSDate()}

        else {
        dt = DateTime.fromFormat(key, "yyyy-MM-dd",{ zone: "utc" });
        jsDate = dt.toJSDate()
        }
          chartData.push({
            date: jsDate,
            entrate: entrateDiv[key] || 0,
            stipendi: stipendiDiv[key] || 0,
            spese: speseDiv[key] || 0,
            profitto: profittoDiv[key] || 0,
          });
        }
        $("#chartContainer").dxChart("instance").option("dataSource",chartData)
        $("#chartContainer").dxChart("instance").option("title",newIndex===0 ? "Andamento Mensile": newIndex===1 ? "Andamento Settimanale":"Andamento Giornaliero")
        let label={}
        let tooltip={}
         if (newIndex === 0) {
           label = {
            format: "monthAndYear"  // Mostra "dicembre 2024"
          };
           tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
                html:
                  "<b>Valore:</b> " +
                  `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +
                  `${DateTime.fromJSDate(pointInfo.argument).setLocale("it").toFormat("LLLL yyyy")}`
              };
            }
          };
        }
    else if (newIndex===1){
        label= {
          customizeText: function (arg) {
            const dt = DateTime.fromJSDate(arg.value, { zone: 'utc' });
            return"Settimana del " + dt.toFormat("dd/MM/yyyy") // Mostra "dicembre 2024"
          }
        }
        tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
                html:
                  "<b>Valore:</b> " +
                  `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +
                  `Settimana del ${DateTime.fromJSDate(pointInfo.argument,{ zone: 'utc' }).setLocale("it").toFormat("dd/MM/yyyy")}`
              };
            }
          };
    }
    else {
    label= {
      customizeText: function (arg) {
        const dt = DateTime.fromJSDate(arg.value, { zone: 'utc' });
        return  dt.toFormat("dd/MM/yyyy");
      }
    }
    tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
                html:
                  "<b>Valore:</b> " +
                  `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>Riferimento: </b>` +
                  `${DateTime.fromJSDate(pointInfo.argument).setLocale("it").toFormat("dd/MM/yyyy")}`
              };
            }
          };
    }
    formattedRows = chartData.map((row, index) => ({
        data: row.date,
        entrate: row.entrate,
        spese: row.spese,
        stipendi: row.stipendi,
        profitto: row.profitto,
      }));
    formattedRows=formattedRows.sort((a, b) => a.data - b.data);
    const allineamento="center"
    let dataD=null
    $("#datagridDettagli").dxDataGrid("instance").option({
        dataSource:formattedRows,
        columns:[{dataField: "data", caption: "Data riferimento", alignment:allineamento,customizeText:function (e){
        if (newIndex===0)
        return DateTime.fromJSDate(e.value, { zone: 'utc' }).setLocale("it").toFormat("LLLL yyyy")
        else if (newIndex===1){
            dataD = DateTime.fromJSDate(e.value, { zone: 'utc' });
            return"Settimana del " + dataD.toFormat("dd/MM/yyyy")
        }
        else {
            return DateTime.fromJSDate(e.value,{ zone: 'utc' }).setLocale("it").toFormat("dd/MM/yyyy")
        }
        }},
            {dataField: "entrate", caption: "Entrate totali", alignment:allineamento,customizeText:function (e){if (e.value) {return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}else {return null}}},
            {dataField: "spese", caption: "Spese totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "stipendi", caption: "Stipendi totali", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField: "profitto", caption: "Profitto totale", alignment:allineamento,customizeText:function (e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
        {
            type: "buttons",
            width:"50px",
            buttons: [
              {
                hint: "Dettagli periodo",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() =>
                      handleClick(cellInfo,periodiDettagliati[newIndex+1],datiUtenti,datiCambi)}
                    />
                  );
                },
              }
            ],
          },
        ],})

    $("#chartContainer").dxChart("instance").option("tooltip",tooltip)
        $("#chartContainer").css({
  marginBottom: "30px",
});

      }
      })
      $('#divisioneDati').dxTabs("instance").option("selectedIndex", 0)
      let formattedRowsCreditiPrenotazioni=[]
        let formattedRowsCreditiExtra=[]
        for (let row of soldiFuori){
                    formattedRowsCreditiPrenotazioni.push({
            checkin: convertDate(row.bookingcheckindate).toISO({ includeOffset: false }),
            nome: row.bookingreference,
            checkout: convertDate(row.bookingcheckoutdate).toISO({ includeOffset: false }),
            costo: row.costoStanza,
            pagato:row.bookingadvancepaid,
            saldare:(row.bookingtotcost*(1-(row.bookingdiscount/100)))-row.bookingadvancepaid,
          })

        }
        const containerLezioni = document.getElementById("LezioniFuoriContainer");
        containerLezioni.innerHTML = ""; // ← pulisce il contenuto precedente

        if (formattedRowsCreditiPrenotazioni.length > 0) {
            const generaleLezioni = document.createElement("div");
            generaleLezioni.id = "contenitoreGeneraleLezioni";

            const commentoLezioni = document.createElement("div");
            commentoLezioni.innerText = "Crediti Prenotazioni";
            commentoLezioni.style.fontFamily = "Poppins";
            commentoLezioni.style.fontSize = "25px";
            commentoLezioni.style.fontWeight = "bold";
            commentoLezioni.style.margin="10px"
            const tabellaLezioni = document.createElement("div");
            tabellaLezioni.id = "datagridPrenotazioniFuori";

            generaleLezioni.appendChild(commentoLezioni);
            generaleLezioni.appendChild(tabellaLezioni);
            containerLezioni.appendChild(generaleLezioni);
        }
        $("#datagridPrenotazioniFuori").dxDataGrid({
        dataSource:formattedRowsCreditiPrenotazioni,
        columns:[{dataField:"checkin",caption:"Data Check-in",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"checkout",caption:"Data Check-in",alignment:allineamento,customizeText:function(e){return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")}},
            {dataField:"nome",caption:"Nome Cliente",alignment:allineamento,},
            {dataField:"costo",caption:"Costo prenotazione",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField:"pagato",caption:"Anticipo prenotazione",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            {dataField:"saldare",caption:"Da saldare",alignment:allineamento,customizeText:function(e){return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
            ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        })
      $("#infoDettagli").dxPopup({
    width: "80%",
    height: '90%',
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const popupHeight = e.component.option("height");
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    })}});








        }
    fetchDati()
    },[])
    return <div >
            <h2>Analisi economica</h2>
            <div style={{display:"flex",alignItems: "center",justifyContent: "space-between",}}>
            <div id="infoDettagli"></div>
            <div id="dateBoxInizio"></div>
            <div>

        <i className="fas fa-arrow-right"></i>
      </div>
            <div id="dateBoxFine"></div>
            </div>
            <div id="divGen" className="kpi-grid"></div>
            <div id="divisioneDati"></div>
            <div id="chartContainer"></div>
            <div style={{display:"flex",width:"100%",height:"auto",alignItems: "center",justifyContent: "space-between",}}>
            <div id="chartPieEntrate"></div>
            <div id="chartPieSpese"></div>
            </div>
            <div id="datagridDettagli"></div>
            <div id="LezioniFuoriContainer"></div>
            <div id="NoleggiFuoriContainer"></div>
            <div id="StorageFuoriContainer"></div>
            <div id="loadingOverlay">
              <div className="spinner">
                <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
              </div>
            </div>
          </div>

}

export default AnalisiEconomicaCasa;